import { render, staticRenderFns } from "./NavBarFaq.vue?vue&type=template&id=1311042a&scoped=true"
import script from "./NavBarFaq.vue?vue&type=script&lang=js"
export * from "./NavBarFaq.vue?vue&type=script&lang=js"
import style0 from "./NavBarFaq.vue?vue&type=style&index=0&id=1311042a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1311042a",
  null
  
)

export default component.exports